import React from 'react';
import { useSelector } from 'react-redux';

import { useDataType } from '../../../common/hooks/use-data-type';
import { DATA_TYPE } from '../../../common/config/data-type';
import {
    roundSelector,
    statsLeadersBenchmarkingSelector,
    statsLeadersDataTypeSelector
} from '../../../../../../store/js/modules/statspro/stats-leaders/selectors';
import { composeGetTranslation } from '../../../../../../../../common/react/utils/translations';
import { ToggleInput } from '../../../../../../../../common/react/components/ToggleInput';
import { UPDATE_DATA_TYPE } from '../../../../../../store/js/modules/statspro/stats-leaders/actions';

export const DataTypeToggle = () => {
    const round = useSelector(roundSelector);
    const benchmarking = useSelector(statsLeadersBenchmarkingSelector);
    const initialDataType = useSelector(statsLeadersDataTypeSelector);

    const { dataType, updateDataType } = useDataType({
        initialDataType,
        onUpdateActionCreator: UPDATE_DATA_TYPE.request,
        isBenchmarkingActive: benchmarking.isActive
    });

    const getTranslation = composeGetTranslation(
        'label.statsLeaders.dataType.'
    );

    return (
        <ToggleInput
            id="stats-leaders-data-type-toggle"
            value={
                dataType.type.toLowerCase().includes(DATA_TYPE.TOTALS)
                    ? DATA_TYPE.TOTALS
                    : DATA_TYPE.AVERAGES
            }
            onChange={updateDataType}
            options={[
                {
                    label: getTranslation(DATA_TYPE.TOTALS),
                    value: DATA_TYPE.TOTALS
                },
                {
                    label: getTranslation(DATA_TYPE.AVERAGES),
                    value: DATA_TYPE.AVERAGES,
                    disabled: !!round
                }
            ]}
        />
    );
};
